<template>
  <div>
    <h4>{{ text }}</h4>
    <b-form-group class="w-100" label-for="add-course-exercise">
      <validation-provider
        #default="{ errors }"
        name="add-course-exercise"
        vid="add-course-exercise"
        class="d-flex justify-content-start align-items-center"
      >
        <b-form-checkbox
          v-model="active"
          name="add-course-exercise-active"
          switch
          inline
          unchecked-value="0"
          value="1"
        >
          شروع تمرین با اتمام مشاهده جلسه
        </b-form-checkbox>

        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
    <div class="d-flex justify-content-between flex-wrap">
      <b-form-group
        v-if="!Number(active)"
        label=" * زمان شروع تمرین"
        label-for="add-session-exercise-started-at"
      >
        <validation-provider
          #default="{ errors }"
          name="started-at"
          vid="started-at"
          rules="required"
        >
          <date-picker
            v-model="started_at"
            autocomplete="on"
            id="add-session-exercise-started-at"
            type="datetime"
            clearable
            name="add-session-exercise-started-at"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
      <b-form-group
        v-if="Number(active) && !deadline_at"
        label=" * مدت زمان (ساعت)"
        label-for="add-session-exercise-duration"
      >
        <validation-provider
          #default="{ errors }"
          name="duration"
          vid="duration"
          rules="required"
        >
          <b-form-input
            type="number"
            v-model="duration"
            autocomplete="on"
            id="add-session-exercise-duration"
            clearable
            min="1"
            name="add-session-exercise-duration"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
      <b-form-group
        label=" * زمان پایان تمرین"
        label-for="add-session-exercise-finished-at"
        v-if="!duration"
      >
        <validation-provider
          #default="{ errors }"
          name="exercise-finished-at"
          vid="exercise-finished-at"
          rules="required"
        >
          <date-picker
            class="mb-0"
            v-model="deadline_at"
            autocomplete="on"
            id="add-session-exercise-finished-at"
            type="datetime"
            name="add-session-exercise-finished-at"
            clearable
          />

          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BFormInput,
  BBadge,
  BFormCheckbox,
  BListGroupItem,
} from "bootstrap-vue";
import SelectBox from "@/@core/components/select-box/SelectBox.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
export default {
  components: {
    BButton,
    SelectBox,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormCheckbox,
    BBadge,
    BListGroupItem,
  },
  data() {
    return {
      required,
      active: "0",
      id: null,
      text: "",
      duration: "",
      deadline_at: "",
      started_at: "",
    };
  },
  props: {
    exercise: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    Object.keys(this.exercise).map((key) => {
      this[key] = this.exercise[key];
    });
    if (this.duration) {
      this.active = "1";
    }
    if (this.deadline_at && !this.started_at) {
      this.active = "1";
    }
    if (this.deadline_at && this.started_at) {
      this.active = "0";
    }
    if (this.active == "1") {
      this.started_at = "";
    } else {
      this.duration = "";
    }
  },
  watch: {
    active(val) {
      if (val == "1") {
        this.started_at = "";
      } else {
        this.duration = "";
      }
    },
    exercise(val) {
      if (val.duration) {
        this.active = "1";
      }
      if (val.deadline_at && !val.started_at) {
        this.active = "1";
      }
      if (val.deadline_at && val.started_at) {
        this.active = "0";
      }
      Object.keys(val).map((key) => {
        this[key] = val[key];
      });
    },
    newExercise(val) {
      Object.keys(val).map((key) => {
        this.exercise[key] = this[key];
      });
      this.$emit("input", val);
    },
  },
  computed: {
    newExercise() {
      return {
        id: this.id,
        text: this.text,
        duration: this.duration,
        deadline_at: this.deadline_at,
        started_at: this.started_at,
      };
    },
  },
};
</script>

<style></style>
